$(document).on('click', 'a[href^=\\#]', function() {
	if (location.pathname.replace(/^\//,'') == this.pathname.replace(/^\//,'') && location.hostname == this.hostname) {
		var target = $(this.hash);
		target = target.length ? target : $('[name=' + this.hash.slice(1) +']');
		if (target.length) {
		$('html,body').animate({
			scrollTop: target.offset().top - 50,
		}, 500);
		return false;
		}
	}
});



// WEBPACK FOOTER //
// ./scripts/common/_scroll.js